import { render, staticRenderFns } from "./IconItaly.vue?vue&type=template&id=69687cc9&"
import script from "./IconItaly.vue?vue&type=script&lang=ts&"
export * from "./IconItaly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports